import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';

import type { BottomSheetInstance } from '../../components/bottomSheet/types';
import type { CoreRootState } from '../CoreStore';
import { headerActions } from '../slices/header/slice';

export const bottomSheetMiddleware = createListenerMiddleware<CoreRootState>();

// toggles modal window visibility when user clicks some bottom sheet control
bottomSheetMiddleware.startListening({
  matcher: isAnyOf(headerActions.setBottomSheetOpen, headerActions.setOverrideBottomSheetOpen),
  effect: ({ payload }, { dispatch }) => {
    const { instance } = payload as { state: boolean; instance: BottomSheetInstance };

    // open bottom sheet modals
    dispatch(headerActions.setOpenedDrawer(instance));
    dispatch(headerActions.setOpenedBottomSheetModal(instance));
  },
});

// close other core modals if bottom sheet modal is opened
bottomSheetMiddleware.startListening({
  actionCreator: headerActions.setOverrideBottomSheetOpen,
  effect: ({ payload }, { dispatch }) => {
    const { state } = payload as { state: boolean };

    if (state) dispatch(headerActions.setOpenedModal(null));
  },
});
